/* global trapFocus */

if (!customElements.get('cart-items')) {
  const t26BuildCartRequest = ({
    line,
    lineKey,
    serviceKey,
    quantity,
    sections,
    sectionsUrl,
    cartChangeRoute,
    cartUpdateRoute
  }) => {
    const parsedQuantity = Number(quantity);
    const sharedBody = {
      sections,
      sections_url: sectionsUrl
    };

    if (serviceKey && (!Number.isInteger(parsedQuantity) || parsedQuantity < 0 || parsedQuantity > 5)) {
      return { error: 'Cutting Service is available for up to 5 yards per fabric.' };
    }

    if (serviceKey && parsedQuantity === 0) {
      return {
        route: cartUpdateRoute,
        body: {
          updates: {
            [lineKey]: 0,
            [serviceKey]: 0
          },
          ...sharedBody
        }
      };
    }

    return {
      route: cartChangeRoute,
      body: {
        ...(lineKey ? { id: lineKey } : { line }),
        quantity: parsedQuantity,
        ...sharedBody
      }
    };
  };

  window.T26CuttingCartHelpers = {
    t26BuildCartRequest
  };

  class CartItems extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.empty === 'false') this.init();
    }

    init() {
      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.cartDrawer = document.getElementById('cart-drawer');
      this.itemStatus = document.getElementById('cart-line-item-status');
      const renderedTotalItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value, 10), 0
      );
      this.currentTotalItemCount = Array.isArray(theme.cart?.items)
        ? theme.cart.items.reduce((total, item) => total + Number(item.quantity), 0)
        : renderedTotalItemCount;

      this.currentQuantities = {};
      this.querySelectorAll('.cart-item').forEach((item) => {
        const quantityInput = item.querySelector('.qty-input__input');
        if (item.dataset.lineKey && quantityInput) {
          this.currentQuantities[item.dataset.lineKey] = Number(quantityInput.value);
        }
      });

      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('change', this.handleChange.bind(this));
    }

    /**
     * Handles 'click' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      if (!evt.target.matches('.js-remove-item')) return;
      evt.preventDefault();
      this.updateQuantity(evt.target.dataset.index, 0);
    }

    /**
     * Handles 'change' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleChange(evt) {
      this.updateQuantity(evt.target.dataset.index, evt.target.value, document.activeElement.name);
    }

    /**
     * Updates the quantity of a line item.
     * @param {number} line - Line item index.
     * @param {number} quantity - Quantity to set.
     * @param {string} name - Active element name.
     */
    async updateQuantity(line, quantity, name) {
      const cartDrawerContent = this.cartDrawer ? this.cartDrawer.querySelector('.drawer__content') : null;
      const cartDrawerContentScroll = cartDrawerContent ? cartDrawerContent.scrollTop : 0;
      const cartDrawerScroll = this.cartDrawer ? this.cartDrawer.scrollTop : 0;
      const lineItem = document.getElementById(`cart-item-${line}`);
      if (!lineItem) return;

      const lineErrorsId = `line-item-error-${line}`;
      const lineErrors = document.getElementById(lineErrorsId);
      const sectionsToRender = this.getSectionsToRender();
      const sections = sectionsToRender.map((section) => section.section);
      const lineKey = lineItem.dataset.lineKey;
      const oldQuantity = this.currentQuantities[lineKey];
      if (theme.t26CartMutation?.owner) {
        const input = lineItem.querySelector('.qty-input__input');
        if (input) {
          input.value = oldQuantity;
          const control = input.closest('quantity-input');
          if (control) control.currentQty = oldQuantity;
        }
        return;
      }
      const request = t26BuildCartRequest({
        line,
        lineKey,
        serviceKey: lineItem.dataset.t26CuttingServiceKey,
        quantity,
        sections: [...new Set(sections)],
        sectionsUrl: window.location.pathname,
        cartChangeRoute: theme.routes.cartChange,
        cartUpdateRoute: theme.routes.cartUpdate
      });

      if (request.error) {
        if (lineErrors) {
          lineErrors.textContent = request.error;
          lineErrors.hidden = false;
        }
        const invalidInput = document.getElementById(`quantity-${line}`);
        if (invalidInput) {
          invalidInput.value = invalidInput.dataset.initialValue;
          const quantityElement = invalidInput.closest('quantity-input');
          if (quantityElement) quantityElement.currentQty = invalidInput.dataset.initialValue;
        }
        return;
      }

      if (theme.t26CartMutation && !theme.t26CartMutation.begin(this)) return;
      this.cartDrawer?.t26SetBusy?.(true);
      this.enableLoading(line);

      // clear all errors except this line's (which will be refreshed after this update)
      document.querySelectorAll(`.cart-errors, .cart-item__error:not([id="${lineErrorsId}"])`).forEach((el) => {
        el.innerHTML = '';
        el.hidden = true;
      });

      this.fetchRequestOpts.body = JSON.stringify(request.body);
      let t26Unresolved = false;
      let t26FocusCount;
      try {
        const variantId = Number(lineItem.dataset.variantId);
        const oldTotalQuantity = this.currentTotalItemCount;
        const response = await fetch(request.route, this.fetchRequestOpts);
        const data = await response.json();

        if (!response.ok) throw new Error(data.errors || response.status);

        const newTotalQuantity = data.item_count;
        theme.cart = theme.cart || { items: [] };
        theme.cart.items = data.items.map((item) => ({
          variantId: item.variant_id,
          quantity: item.quantity
        }));
        const newLine = data.items.find((item) => item.key === lineKey);
        const newQuantity = newLine ? Number(newLine.quantity) : 0;

        if (this.cartDrawer) {
          cartDrawerContent.classList.toggle('drawer__content--flex', newTotalQuantity === 0);

          if (newTotalQuantity === 0) {
            const recommendations = this.cartDrawer.querySelector('product-recommendations');
            if (recommendations) recommendations.remove();
          }
        } else if (newTotalQuantity === 0) {
          // We're on the Cart page
          const cartTitle = this.closest('.cc-main-cart').querySelector('.js-cart-title');
          if (cartTitle) cartTitle.style.textAlign = 'center';

          const cartSummaryCss = document.getElementById('cart-summary-css');
          if (cartSummaryCss) cartSummaryCss.remove();

          const cartContent = document.getElementById('cart-summary-and-blocks');
          if (cartContent) cartContent.hidden = true;
        }

        CartItems.renderSections(data.sections, sectionsToRender);

        if (this.cartDrawer && newTotalQuantity === 0) {
          cartDrawerContent.classList.add('grow', 'flex', 'items-center');

          if (this.cartDrawer.querySelector('promoted-products')) {
            this.cartDrawer
              .querySelector('.drawer__content')
              .classList.toggle('drawer__empty-with-promotions', newTotalQuantity === 0);
          }
        }

        this.updateRecommendations(data.item_count > 0 ? data.items[0].product_id : null);
        this.updateLiveRegions();
        t26FocusCount = newTotalQuantity;
        this.dataset.empty = newTotalQuantity === 0;
        this.currentTotalItemCount = newTotalQuantity;

        // Fire the on:line-item:change event if the line item quantity has changed
        if (oldTotalQuantity !== newTotalQuantity) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: data,
              variantId,
              oldQuantity,
              newQuantity,
              t26CuttingGroup: lineItem.dataset.t26CuttingGroup || null
            }
          }));
        }

        this.currentQuantities = Object.fromEntries(
          data.items.map((item) => [item.key, Number(item.quantity)])
        );

        if (lineErrors) {
          lineErrors.innerHTML = '';
          lineErrors.hidden = true;
        }
      } catch (error) {
        if (lineErrors) {
          if (/^[0-9]+$/.test(error.message)) {
            lineErrors.textContent = theme.strings.cartError;
          } else {
            lineErrors.textContent = error.message;
          }
          lineErrors.hidden = false;
        }
        console.log(error); // eslint-disable-line

        this.querySelectorAll('.cart-item__loader').forEach((loader) => {
          loader.hidden = true;
        });

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));

        const input = document.getElementById(`quantity-${line}`);
        if (input) {
          input.value = input.dataset.initialValue;
          const quantityElement = input.closest('quantity-input');
          if (quantityElement) quantityElement.currentQty = input.dataset.initialValue;
        }
        if (this.cartDrawer?.t26RecoverCart) {
          try { await this.cartDrawer.t26RecoverCart(); } catch (_) { t26Unresolved = true; }
          this.cartDrawer.t26FinishAdd(this.cartDrawer.dataset.t26AddError, t26Unresolved);
        }
      } finally {
        if (!t26Unresolved) theme.t26CartMutation?.end(this);
        this.cartDrawer?.t26SetBusy?.(t26Unresolved);
        this.classList.remove('pointer-events-none');
        if (!t26Unresolved && t26FocusCount !== undefined && (!this.cartDrawer || this.cartDrawer.hasAttribute('open'))) {
          this.setFocus(line, t26FocusCount, name);
        }

        // Attempt to maintain the same scroll position in the cart drawer
        if (cartDrawerContent) {
          requestAnimationFrame(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; });
          setTimeout(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; }, 0);
          requestAnimationFrame(() => { this.cartDrawer.scrollTop = cartDrawerScroll; });
          setTimeout(() => { this.cartDrawer.scrollTop = cartDrawerScroll; }, 0);
        }
      }
    }

    /**
     * Refreshes the cart by rerendering its sections and updating its product recommendations.
     */
    async refresh(t26Owner = null) {
      if (theme.t26CartMutation?.owner && theme.t26CartMutation.owner !== t26Owner) return;
      const t26Revision = theme.t26CartMutation?.revision;
      const errors = document.getElementById('cart-errors');
      try {
        const sectionsToRender = this.getSectionsToRender();
        const sections = sectionsToRender.map((section) => section.section);
        const response = await fetch(`?sections=${[...new Set(sections)]}`);

        // The status is 400, refresh the whole cart and stop
        if (response.status === 400 && this.cartDrawer) {
          this.cartDrawer.refresh(true);
          return;
        }

        const data = await response.json();

        if (t26Revision !== theme.t26CartMutation?.revision) return;

        if (!response.ok) throw new Error(response.status);

        CartItems.renderSections(data, sectionsToRender);

        const firstCartItem = this.querySelector('.cart-item:first-child');
        this.updateRecommendations(firstCartItem ? firstCartItem.dataset.productId : null);

        errors.innerHTML = '';
        errors.hidden = true;
      } catch (error) {
        errors.textContent = theme.strings.cartError;
        errors.hidden = false;
        console.log(error); // eslint-disable-line

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));
      }
    }

    /**
     * Returns an array of objects containing required section details.
     * @returns {Array}
     */
    getSectionsToRender() {
      let sections = [
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];

      if (this.cartDrawer) {
        const cartDrawerId = this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');
        sections = [
          ...sections,
          {
            id: 'free-shipping-notice',
            section: cartDrawerId,
            selector: '.free-shipping-notice'
          },
          {
            id: 'cart-items',
            section: cartDrawerId,
            selector: 'cart-items'
          },
          {
            id: 'cart-promoted-products',
            section: cartDrawerId,
            selector: '#cart-promoted-products'
          },
          {
            id: 'cart-drawer',
            section: cartDrawerId,
            selector: '.cart-drawer__summary'
          },
          {
            id: 'cart-drawer-media-promotion',
            section: cartDrawerId,
            selector: '#cart-drawer-media-promotion'
          }
        ];
      } else {
        sections = [
          ...sections,
          {
            id: 'free-shipping-notice',
            section: 'free-shipping-notice',
            selector: '.free-shipping-notice'
          },
          {
            id: 'cart-items',
            section: this.dataset.section,
            selector: 'cart-items'
          },
          {
            id: 'cart-summary',
            section: document.getElementById('cart-summary').dataset.section,
            selector: '.cart__summary'
          }
        ];
      }

      return sections;
    }

    /**
     * Renders each requested target while parsing duplicate section HTML only once.
     * @param {object} sectionHtml - HTML keyed by section ID.
     * @param {Array} sections - Section targets to render.
     */
    static renderSections(sectionHtml, sections) {
      const templates = new Map();

      sections.forEach((section) => {
        const sectionEl = document.getElementById(section.id);
        const html = sectionHtml[section.section];
        if (!sectionEl || typeof html !== 'string') return;

        if (!templates.has(section.section)) {
          const template = document.createElement('template');
          template.innerHTML = html;
          templates.set(section.section, template);
        }

        const source = templates.get(section.section).content.querySelector(section.selector);
        const target = sectionEl.querySelector(section.selector) || sectionEl;
        target.innerHTML = source ? source.innerHTML : '';
      });
    }

    /**
     * Shows a loading icon over a line item.
     * @param {string} line - Line item index.
     */
    enableLoading(line) {
      this.classList.add('pointer-events-none');

      const loader = this.querySelector(`#cart-item-${line} .cart-item__loader`);
      if (loader) loader.hidden = false;

      document.activeElement.blur();
      if (this.itemStatus) this.itemStatus.setAttribute('aria-hidden', 'false');
    }

    /**
     * Updates the cart recommendations.
     * @param {string} productId - The product id for which to find recommendations.
     */
    updateRecommendations(productId) {
      this.recommendations = this.recommendations || document.getElementById('cart-recommendations');
      if (!this.recommendations) return;

      if (productId) {
        if (String(this.recommendations.dataset.productId) === String(productId)) return;
        this.recommendations.dataset.productId = productId;
        this.recommendations.init();
      } else {
        this.recommendations.innerHTML = '';
      }
    }

    /**
     * Updates the live regions.
     */
    updateLiveRegions() {
      this.itemStatus.setAttribute('aria-hidden', 'true');

      const cartStatus = document.getElementById('cart-live-region-text');
      cartStatus.setAttribute('aria-hidden', 'false');

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    /**
     * Traps focus in the relevant container or focuses the active element.
     * @param {number} line - Line item index.
     * @param {number} itemCount - Item count.
     * @param {string} name - Active element name.
     */
    setFocus(line, itemCount, name) {
      const lineItem = document.getElementById(`cart-item-${line}`);
      let activeEl;

      if (lineItem) {
        activeEl = lineItem.querySelector(`[name="${name}"]`);
      }

      if (this.cartDrawer) {
        if (lineItem && activeEl) {
          trapFocus(this.cartDrawer, activeEl);
        } else if (itemCount === 0) {
          trapFocus(
            this.cartDrawer.querySelector('.js-cart-empty'),
            this.cartDrawer.querySelector('a')
          );
        } else if (this.cartDrawer.querySelector('.cart-item')) {
          trapFocus(this.cartDrawer, document.querySelector('.js-item-name'));
        }
      } else if (lineItem && activeEl) {
        activeEl.focus();
      }
    }
  }

  customElements.define('cart-items', CartItems);
}
